<div class="menu" (click)="menuClicked($event)">
    <div class="main-menu">
        <perfect-scrollbar class="scroll" [config]="{suppressScrollX: true}">
            <ul class="list-unstyled">
                <li *ngFor="let item of menuItems"
                    [ngClass]="{'active': (selectedParentMenu === item.id && viewingParentMenu === '') || viewingParentMenu === item.id}">
                    <a *ngIf="item.newWindow" [href]="item.to" rel="noopener noreferrer" target="_blank">
                        <i [ngClass]="item.icon"></i>{{item.label | translate}}</a>
                    <a *ngIf="!item.newWindow && item.subs &&  item.subs.length>0"
                        (click)="openSubMenu($event,item); false" [href]="item.to">
                        <!-- <i [ngClass]="item.icon"></i> -->
                        <img [src]="'assets/icons/' + item.icon" 
                        alt="{{item.label}}" 
                        width="60" 
                        height="45" 
                        style=" vertical-align: middle; color: white;" />
                         {{item.label | translate}}</a>
                    <a *ngIf="!item.newWindow && (!item.subs || (item.subs &&  item.subs.length===0))"
                        (click)="changeSelectedParentHasNoSubmenu(item.id); false" [routerLink]="item.to">
                        <i [ngClass]="item.icon"></i> {{item.label | translate}}</a>


                </li>
            </ul>

            <!-- <a  class="navbar-logo" style="margin-top: 20px" >
                <span class="logo d-none d-xs-block"></span>
                <span class="logo-mobile d-block d-xs-none"></span>
              </a> -->
        </perfect-scrollbar>
    </div>
    <div class="sub-menu">
        <perfect-scrollbar class="scroll" [config]="{suppressScrollX: true}">
            <ul class="list-unstyled" *ngFor="let item of menuItems" [attr.data-parent]="item.id"
                [ngClass]="{'d-block': (selectedParentMenu === item.id && viewingParentMenu==='') || viewingParentMenu === item.id}">
                <li *ngFor="let sub of item.subs"
                    [ngClass]="{'active': currentUrl === sub.to ,'has-sub-item' : sub.subs&& sub.subs.length>0 }">
                    <a *ngIf="sub.newWindow" [href]="sub.to" rel="noopener noreferrer" target="_blank">
                        <i [ngClass]="sub.icon"></i>
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a>
                    <!-- <a *ngIf="!sub.newWindow && (!sub.subs || sub.subs.length<=0)" [routerLink]="[sub.to]"
                        routerLinkActive="active">
                        <i [ngClass]="sub.icon"></i>
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a> -->
                    <!-- <a *ngIf="!sub.newWindow && (!sub.subs || sub.subs.length <= 0)" 
                        [routerLink]="[sub.to]" 
                        routerLinkActive="active">

                        <img [src]="'assets/icons/subicons/' + sub.icon" 
                            alt="{{ sub.label }}" 
                            width="45" 
                            height="35" 
                            style="vertical-align: middle;" />

                            
                        <span class="d-inline-block">{{ sub.label | translate }}</span>
                        </a> -->



                        <a *ngIf="!sub.newWindow && (!sub.subs || sub.subs.length <= 0)"
   [routerLink]="[sub.to]"
   routerLinkActive="active"
   class="d-flex align-items-center">

  <!-- Image icon (if it contains an image extension) -->
  <ng-container *ngIf="isImage(sub.icon); else fontIcon">
    <img [src]="'assets/icons/subicons/' + sub.icon"
         [alt]="sub.label"
         width="45"
         height="35"
         style="vertical-align: middle; margin-right: 8px;" />
  </ng-container>

  <!-- Font icon fallback -->
  <ng-template #fontIcon>
    <i [ngClass]="sub.icon"
       style="vertical-align: middle; font-size: 20px; margin-right: 8px;"></i>
  </ng-template>

  <span class="d-inline-block">{{ sub.label | translate }}</span>
</a>


                        

                    <a (click)="toggleCollapse(sub.id)" *ngIf="sub.subs && sub.subs.length > 0"
                      [ngClass]="{'rotate-arrow-icon opacity-50 c-pointer': true, 'collapsed': closedCollapseList.includes(sub.id)}">
                        <i class="simple-icon-arrow-down"></i>
                        <span class="d-inline-block">{{sub.label | translate}}</span>
                    </a>
                    <div [collapse]="closedCollapseList.includes(sub.id)"  [isAnimated]="true">
                        <div *ngIf="sub.subs && sub.subs.length > 0">
                            <ul class="list-unstyled inner-level-menu">
                                <li *ngFor="let deepSub of sub.subs" [ngClass]="{'active': currentUrl === deepSub.to}">
                                    <a *ngIf="deepSub.newWindow" [href]="deepSub.to" rel="noopener noreferrer"
                                        target="_blank">
                                        <i [ngClass]="deepSub.icon"></i>
                                        <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                    </a>
                                    <a *ngIf="!deepSub.newWindow && (!deepSub.subs || deepSub.subs.length<=0)"
                                        [routerLink]="[deepSub.to]" routerLinkActive="active">
                                        <i [ngClass]="deepSub.icon"></i>
                                        <span class="d-inline-block">{{deepSub.label | translate}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
            </ul>

         
            

        </perfect-scrollbar>
    </div>
</div>
<ngx-spinner bdColor="rgba(239,231,231,0.1)" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="true"><p style="color: white"> Please wait... </p></ngx-spinner>
